import OutsideAlerter from "./OutsideAlterter";
export default OutsideAlerter;
